import {
  Build,
  BuildOutlined,
  Category,
  CategoryOutlined,
  ContentPasteGoOutlined,
  Explore,
  ExploreOutlined,
  Home,
  HomeOutlined,
  LocalOffer,
  LocalOfferOutlined,
  Settings,
  SettingsOutlined,
  TouchApp,
  TouchAppOutlined,
  Visibility,
  VisibilityOutlined,
  Work,
  WorkOutline,
} from "@mui/icons-material";
import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "../../context/auth-context";
import { DiscoveryContext as BrandAuditDiscoveryContext } from "../../luminaire/BrandAudit/discovery-context";
import { DiscoveryContext as DiscoveryContextV2 } from "../../luminaire/DiscoveryV2/discovery-context";
import { DiscoveryContext } from "../../luminaire/Discovery/discovery-context";
import { CategoryAnalysisContext } from "../../luminaire/CategoryAnalysis/category-analysis-context";
import styles from "./Sidebar.module.css";
import { ENTITY_LABELS } from "../../utils/labelMapping";

const Sidebar = () => {
  const { user } = useContext(AuthContext);
  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryCtxV2 = useContext(DiscoveryContextV2);
  const brandAuditDiscoveryContext = useContext(BrandAuditDiscoveryContext);
  const categoryAnalysisCtx = useContext(CategoryAnalysisContext);
  const customer_id = user && user?.customer_id;
  const isAdmin =
    user?.user_role?.role?.name == "Company admin" ||
    user?.user_role?.role?.name == "Super User";

  const navItems = [
    {
      target: "prompt-engine",
      label: "LLM Insights",
      icon: Build,
      iconOutlined: BuildOutlined,
    },
    // {
    //   target: "discovery",
    //   label: "Discovery",
    //   icon: Explore,
    //   iconOutlined: ExploreOutlined,
    // },
    {
      target: "discoveryV2",
      label: "Discovery",
      icon: Explore,
      iconOutlined: ExploreOutlined,
    },
    // {
    //   target: "brand-audit",
    //   label: `${ENTITY_LABELS.brand} and ${ENTITY_LABELS.product} Audit`,
    //   icon: Work,
    //   iconOutlined: WorkOutline,
    // },
    // {
    //   target: "category-discovery",
    //   label: "Category Discovery",
    //   icon: Category,
    //   iconOutlined: CategoryOutlined,
    // },
    // {
    //   target: "brand-monitoring",
    //   // label: `${ENTITY_LABELS.brand} and ${ENTITY_LABELS.product} Analysis and Monitoring`,
    //   label: `${ENTITY_LABELS.brand} Analysis and Monitoring`,
    //   icon: LocalOffer,
    //   iconOutlined: LocalOfferOutlined,
    // },
    // {
    //   target: "product-monitoring",
    //   label: `${ENTITY_LABELS.product} Analysis and Monitoring`,
    //   icon: Work,
    //   iconOutlined: WorkOutline,
    // },
    // {
    //   target: "conversations",
    //   label: "Conversations",
    //   icon: ContentPasteGoOutlined,
    //   iconOutlined: ContentPasteGoOutlined,
    // },

    // {
    //   target: "metric-content",
    //   label: "Content Mapping",
    //   icon: ContentPasteGoOutlined,
    //   iconOutlined: ContentPasteGoOutlined,
    // },
    // {
    //   target: "llm-reporting",
    //   label: "Reporting",
    //   icon: ContentPasteGoOutlined,
    //   iconOutlined: ContentPasteGoOutlined,
    // },
    // {
    //   target: "buying-journey",
    //   label: "Metric Content Mapping",
    //   icon: ContentPasteGoOutlined,
    //   iconOutlined: ContentPasteGoOutlined,
    // },
    // {
    //   target: "purchase-funnel",
    //   label: "Playground",
    //   icon: ContentPasteGoOutlined,
    //   iconOutlined: ContentPasteGoOutlined,
    // },

    // The "Settings" NavLink will be added conditionally
  ];

  if (user?.is_brandaudit_enabled && !navItems.some((item) => item.target === "brand-audit")) {
    // Find index of existing discoveryV2
    const discoveryIndex = navItems.findIndex(item => item.target === "discoveryV2");

    if (discoveryIndex !== -1) {
      // Push brand audit right after discoveryV2
      navItems.splice(discoveryIndex + 1, 0, {
        target: "brand-audit",
        label: ENTITY_LABELS.hasProductEntity
          ? `${ENTITY_LABELS.brand} and ${ENTITY_LABELS.product} Audit`
          : `${ENTITY_LABELS.brand} Audit`,
        icon: Explore,
        iconOutlined: ExploreOutlined,
      });
    }
  }

  if (user?.is_categoryanalysis_enabled && !navItems.some((item) => item.target === "category-analysis")) {
    const brandAuditIndex = navItems.findIndex((item) => item.target === "brand-audit");

    if (brandAuditIndex !== -1) {
      navItems.splice(brandAuditIndex + 1, 0, {
        target: "category-analysis",
        label: "Category Analysis",
        icon: Category,
        iconOutlined: CategoryOutlined,
      });
    }
  }

  if (user?.is_monitoring_enable) {
    const categoryAnalysisIndex = navItems.findIndex((item) => item.target === "category-analysis");
    const brandAuditIndex = navItems.findIndex((item) => item.target === "brand-audit");
    const discoveryIndex = navItems.findIndex((item) => item.target === "discoveryV2");
    const insertAt =
      categoryAnalysisIndex !== -1 ? categoryAnalysisIndex + 1 :
      brandAuditIndex !== -1 ? brandAuditIndex + 1 :
      discoveryIndex !== -1 ? discoveryIndex + 1 :
      navItems.length;
    navItems.splice(insertAt, 0,
      {
        target: "brand-monitoring",
        label: `${ENTITY_LABELS.brand} Analysis and Monitoring`,
        icon: LocalOffer,
        iconOutlined: LocalOfferOutlined,
      },
      {
        target: "product-monitoring",
        label: `${ENTITY_LABELS.product} Analysis and Monitoring`,
        icon: Work,
        iconOutlined: WorkOutline,
      }
    );
  }

  if (user?.is_conversation_enabled && !navItems.some((item) => item.target === "conversations")) {
    navItems.push({
      target: "conversations",
      label: "Conversations",
      icon: TouchApp,
      iconOutlined: TouchAppOutlined,
    });
  }

  if (user?.is_contentmap_enabled && !navItems.some((item) => item.target === "metric-content")) {
    navItems.push({
      target: "metric-content",
      label: "Content Mapping",
      icon: TouchApp,
      iconOutlined: TouchAppOutlined,
    });
  }

        if (user?.is_new_homepage_enabled && !navItems.some((item) => item.target === "home-page-new")) {
    navItems.unshift({
      target: "home-page-new",
      label: "Home Page - New",
      icon: Home,
      iconOutlined: HomeOutlined,
    });
  }

  if (user?.is_homescreen_enabled && !navItems.some((item) => item.target === "home")) {
    navItems.unshift({
      target: "home",
      label: "Home",
      icon: Home,
      iconOutlined: HomeOutlined,
    });
  }

    if (user?.is_action_enabled && !navItems.some((item) => item.target === "actions")) {
      const productMonitoringIndex = navItems.findIndex((item) => item.target === "product-monitoring");
      const insertAt = productMonitoringIndex !== -1 ? productMonitoringIndex + 1 : navItems.length;
      navItems.splice(insertAt, 0, {
        target: "actions",
        label: "Actions",
        icon: TouchApp,
        iconOutlined: TouchAppOutlined,
      });
    }

  if (user?.is_category_monitoring_enabled && !navItems.some((item) => item.target === "category-monitoring")) {
    const categoryAnalysisIndex = navItems.findIndex((item) => item.target === "category-analysis");
    const insertAt = categoryAnalysisIndex !== -1 ? categoryAnalysisIndex + 1 : navItems.length;
    navItems.splice(insertAt, 0, {
      target: "category-monitoring",
      label: "Category Monitoring",
      icon: Visibility,
      iconOutlined: VisibilityOutlined,
    });
  }



    // if (
    //   user?.is_brandaudit_enabled && !navItems.some((item) => item.target === "brand-audit")
    // ) {
    //   navItems.push(
    //     {
    //       target: "brand-audit",
    //       label: `${ENTITY_LABELS.brand} and ${ENTITY_LABELS.product} Audit`,
    //       icon: Explore,
    //       iconOutlined: ExploreOutlined,
    //     }
    //   );
    // }

    if (
      user?.is_reporting_available && !navItems.some((item) => item.target === "llm-reporting")
    ) {
      navItems.push(
        {
          target: "llm-reporting",
          label: "Reporting",
          icon: ContentPasteGoOutlined,
          iconOutlined: ContentPasteGoOutlined,
        },
      );
    }
  
  return (
      <ul className="nav nav-pills p-3 flex-column mb-auto">
        {navItems.map(
          ({ target, label, icon: Icon, iconOutlined: IconOutlined }) => (
            <li className={styles.navItem} key={target}>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? `${styles.navLink} ${styles.navLinkActive}`
                    : styles.navLink
                }
                onClick={() => {
                  console.log("target", target);
                  if (target === "discovery") {
                    discoveryCtx.updateType("brand");
                  }
                  if (target === "discoveryV2") {
                    discoveryCtxV2.updateType("brand");
                  }
                  if (target === "brand-audit") {
                    brandAuditDiscoveryContext.updateType("brand");
                  }
                  discoveryCtx.updateLanguage("en");
                  discoveryCtxV2.updateLanguage("en");
                  discoveryCtx.resetState();
                  discoveryCtxV2.resetState();
                  discoveryCtxV2.resetFormState(true);
                  brandAuditDiscoveryContext.resetState();
                  brandAuditDiscoveryContext.resetFormState(true);
                  categoryAnalysisCtx.resetState();
                  categoryAnalysisCtx.resetFormState(true);
                }}
                to={target}
              >
                {({ isActive }) => (
                  <React.Fragment>
                    <span
                      className={`${styles.iconWrap} ${isActive ? styles.iconWrapActive : ""
                        }`}
                    >
                      {isActive ? (
                        <Icon className={`${styles.activeIcon}`} />
                      ) : (
                        <IconOutlined className={`${styles.icon}`} />
                      )}
                    </span>
                    <span className={`${styles.labelText}`}>{label}</span>
                  </React.Fragment>
                )}
              </NavLink>
            </li>
          )
        )}

        {/* Conditionally render the "Settings" NavLink for admin users */}
        {isAdmin && user?.is_setting_enable && (
          <li className={styles.navItem} key="settings">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.navLinkActive}`
                  : styles.navLink
              }
              to="settings"
            >
              {({ isActive }) => (
                <React.Fragment>
                  <span
                    className={`${styles.iconWrap} ${isActive ? styles.iconWrapActive : ""
                      }`}
                  >
                    {isActive ? (
                      <Settings className={`${styles.activeIcon}`} />
                    ) : (
                      <SettingsOutlined className={`${styles.icon}`} />
                    )}
                  </span>
                  <span className={`${styles.labelText}`}>Settings</span>
                </React.Fragment>
              )}
            </NavLink>
          </li>
        )}

        {
          // user?.is_template_setting_enabled && !user?.is_readonly_brandaudit &&
          user?.is_template_setting_enabled &&
          <li className={styles.navItem} key="set">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? `${styles.navLink} ${styles.navLinkActive}`
                  : styles.navLink
              }
              to="templateSetting"
            >
              {({ isActive }) => (
                <React.Fragment>
                  <span
                    className={`${styles.iconWrap} ${isActive ? styles.iconWrapActive : ""
                      }`}
                  >
                    {isActive ? (
                      <Settings className={`${styles.activeIcon}`} />
                    ) : (
                      <SettingsOutlined className={`${styles.icon}`} />
                    )}
                  </span>
                  <span className={`${styles.labelText}`}>Template Settings</span>
                </React.Fragment>
              )}
            </NavLink>
          </li>
        }

      </ul >
    );
}

export default Sidebar;
